import { Box, Typography } from "@braintrust/braintrust-ui-components";

import type { ReportType } from "../report-types";

import styles from "./styles.module.scss";

type ReportBodyProps = {
  children: React.ReactNode;
  name: string;
  reportType: ReportType;
};

export const ReportBody = ({ children, name, reportType }: ReportBodyProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <ReportTypeHeader reportType={reportType} />
      <ReportTitle name={name} />
      <ReportSubtitle name={name} />
      {children}
    </Box>
  );
};

type ReportTypeHeaderProps = {
  reportType: ReportType;
};

const ReportTypeHeader = ({ reportType }: ReportTypeHeaderProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 3,
      }}
    >
      <Typography component="p" size="large" fontWeight={500}>
        Report {reportType}
      </Typography>
    </Box>
  );
};

type ReportTitleProps = {
  name: string;
};

const ReportTitle = ({ name }: ReportTitleProps) => {
  return (
    <Box
      className={styles.reportBodyDesc}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "column",
        mb: 3,
      }}
    >
      <Typography component="p" fontWeight={500} variant="title" sx={{ mb: 3 }}>
        Request help from Braintrust to resolve any issues or disputes with{" "}
        {name}.
      </Typography>
      <Typography
        component="p"
        size="large"
        fontWeight={400}
        className={styles.reportBodyInfo}
      >
        <span className={styles.reportBodyIcon}>🔎</span>A moderator from
        Braintrust will review and get back to you within 72 hours.
      </Typography>
    </Box>
  );
};

type ReportSubtitleProps = {
  name: string;
};

const ReportSubtitle = ({ name }: ReportSubtitleProps) => {
  return (
    <Typography
      component="p"
      fontWeight={400}
      size="large"
      sx={{ mb: 1, fontSize: 26 }}
    >
      Why are you reporting {name}?
    </Typography>
  );
};
